<script setup lang="ts">
import {computed } from "vue";
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
const $buildingStore = useCalcBuildingStore();
const frameParams = computed(()=>{
  
  const article = $buildingStore.article;
  const params = article?.params;
  if(params?.width && params?.height &&params?.length)
    {
      return `${params?.width} x ${params?.length} x ${params?.height}`
    }
  return ''
})
</script>

<template>
  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Каркас здания BOX 2.0</span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Каркас (ширина х длина х высота), м</div>
          <div class="blk-win-value">{{frameParams}}</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Уклон кровли</div>
          <div class="blk-win-value">10%</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Количество пролетов</div>
          <div class="blk-win-value">Однопролетное</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Этажи</div>
          <div class="blk-win-value">Одноэтажное</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Пожарная безопасность</div>
          <div class="blk-win-value">V степень огнестойкости</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Срок службы</div>
          <div class="blk-win-value">20 лет</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Количество сборки-разборки</div>
          <div class="blk-win-value">3 раза за расчетный срок службы</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Каркас состоит из типовых металлических конструкций: колонны, ригели,
          связи и
          прогоны. Для сборки используются только болтовые соединения, а сварка всех элементов выполняется
          заранее
          на заводе. Крепление конструкций к основанию осуществляется с помощью анкерных болтов.</p>
        <p class="blk-win-paragraph">Данные конструкции предусматривают возможность многократной разборки и
          последующей сборки — до трёх раз без потери эксплуатационных свойств. Здания ВОХ 2.0
          являются
          некапитальными объектами и не требуют получения разрешения на строительство.</p>
      </div>
    </div>
  </div>



  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Стеновые сэндвич-панели с минераловатным утеплителем
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Толщина, мм</div>
          <div class="blk-win-value">100</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Ширина панели, мм</div>
          <div class="blk-win-value">1190</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Вид профилирования наружных обшивок</div>
          <div class="blk-win-value">Микроволна</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Вид профилирования внутренних обшивок</div>
          <div class="blk-win-value">Трапециевидный</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Климатическое исполнение</div>
          <div class="blk-win-value">О2</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Расчетная температура внутри помещения</div>
          <div class="blk-win-value">20°C</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Температурный диапазон</div>
          <div class="blk-win-value">от -35°C до +28°C</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Сэндвич-панели с наполнителем из минеральной ваты обладают отличными теплоизоляционными свойствами,
           обеспечивают высокую огнестойкость и звукоизоляцию, что делает их идеальным выбором для строительства коммерческих и промышленных
            зданий. Для стеновых панелей применяется горизонтальный монтаж. 
        </p>
      </div>
    </div>
  </div>



  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Кровельные сэндвич-панели с минераловатным утеплителем
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Толщина, мм</div>
          <div class="blk-win-value">120 мм</div>
        </div>

        <div class="blk-win-line">
          <div class="blk-win-label">Вид профилирования внутренних обшивок</div>
          <div class="blk-win-value">Трапециевидный</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Климатическое исполнение</div>
          <div class="blk-win-value">О2</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Расчетная температура внутри помещения</div>
          <div class="blk-win-value">16°C</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Кровельные сэндвич-панели с наполнителем из минеральной ваты отличаются высокой тепло- и шумоизоляцией,
           а также устойчивостью к возгораниям. Эти конструкции используют для обустройства кровли на зданиях различного назначения – 
           от коммерческих до промышленных.

        </p>
      </div>
    </div>
  </div>

  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Подъемно-секционные ворота
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Размеры, мм</div>
          <div class="blk-win-value">4000 (ширина) х 4200 (высота)</div>
        </div>

        <div class="blk-win-line">
          <div class="blk-win-label">Цвет, RAL</div>
          <div class="blk-win-value">9006 (светло-серый)</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Тип открывания</div>
          <div class="blk-win-value">Автоматическое</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Материал</div>
          <div class="blk-win-value">Стальные сэндвич-панели</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Производитель</div>
          <div class="blk-win-value">DOОRHAN</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Подъемно-секционные ворота являются одним из самых популярных и удобных типов ворот
           для быстровозводимых зданий. Такие ворота поднимаются вверх и складываются вдоль потолка, что позволяет свободно 
           перемещаться внутри помещения. 
        </p>
        <p class="blk-win-paragraph">Ворота могут быть установлены по центру между колоннами в любом шаге по продольными сторонам здания,
           кроме шага с вертикальными связями.

        </p>
      </div>
    </div>
  </div>

  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Двери наружные
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Размеры, мм</div>
          <div class="blk-win-value">900 (ширина) х 2100 (высота)</div>
        </div>

        <div class="blk-win-line">
          <div class="blk-win-label">Цвет, RAL</div>
          <div class="blk-win-value">7004 (серый)</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Материал</div>
          <div class="blk-win-value">Металл, утепленные</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Комплектация</div>
          <div class="blk-win-value">Доводчики, замок, ручка</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Одностворчатые металлические двери для складов – это прочные конструкции,
           предназначенные для обеспечения безопасности и защиты складских помещений. Наша компания сотрудничает
            с проверенными отечественными производителями, что гарантирует соответствие продукции всем нормативным требованиям. 

        </p>
      </div>
    </div>
  </div>

  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Окна стандартные
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        <div class="blk-win-line">
          <div class="blk-win-label">Размеры, мм</div>
          <div class="blk-win-value">5980 (длина) х 1170 (высота)</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Материал</div>
          <div class="blk-win-value">ПВХ</div>
        </div>
        <div class="blk-win-line">
          <div class="blk-win-label">Тип открывания</div>
          <div class="blk-win-value">Глухое</div>
        </div>
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Окна – это функциональные и экономичные конструкции, предназначенные для обеспечения естественного освещения
           и вентиляции помещений. 
Окно устанавливается вместо стеновой панели по продольными и торцевым сторонам здания, начиная со второго шага от торца, 
без установки в крайних шагах. Высота расположения окон зафиксирована и зависит от ширины здания.

        </p>
      </div>
    </div>
  </div>


  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Водосточная система
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

       

        <div class="blk-win-line">
          <div class="blk-win-label">Цвет, RAL</div>
          <div class="blk-win-value">7004 (серый)</div>
        </div>
        
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Надежный водосток защищает фундаменты и фасады от осадков и придает зданию завершенный вид. Комплект водосточной системы включает лотки, воронки и трубы из оцинкованной стали с полимерным покрытием в цвет фасадных панелей.

        </p>
      </div>
    </div>
  </div>

  <div class="" style="margin-top: 2rem; text-align: left;">
    <div class="blk-win-header"><span>Элементы снегозадержания
    </span>
    </div>
    <div class="blk-win-wrapper">

      <div class="blk-win-specs">

        

        <div class="blk-win-line">
          <div class="blk-win-label">Цвет, RAL</div>
          <div class="blk-win-value">7004 (серый)</div>
        </div>
        
      </div>

      <div class="blk-win-text">
        <p class="blk-win-paragraph">Снегозадержатели исключают внезапный сход снега с крыши, защищая людей, технику и здание от повреждений. Материал – оцинкованная сталь с полимерным покрытием.

        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.blk-win-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
}

.blk-win-text,
.blk-win-specs {
  flex: 1;
  min-width: 300px;
}

.blk-win-header {

  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0.16px;

  margin-bottom: 16px;
}

.blk-win-subheader {

  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0.16px;

  margin-bottom: 8px;
}

.blk-win-paragraph {
  text-align: start;
  color: #212529;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;

  margin: 0 0 10px;
}

.blk-win-line {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 4px 0;
  font-size: 16px;
}

.blk-win-label {
  color: #212529;

  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;

  margin-right: 10px;
}

.blk-win-value {
  color: #212529;

  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;

  text-align: right;
  white-space: nowrap;
}
</style>
